import { OrganizationUnitType } from '@inplay/models';
import { OptionWithLoading } from '../../../pages/userManagement/userManagement.type';
import { OrgUnit, VenueBranch } from '../../../utils/helper.type';
import { OrgUnitPresentation } from '../orgUnitPresentation.interface';
import {
  OrganizationUnitKey,
  VenuesViewKebabOptions,
  VenuesViewTableHeaderKey,
} from '../../../pages/userManagement/venuesView/venuesView.type';
import { VenuesViewTableColumns } from '../orgUnitPresentationTypes';
import { getOrganizationUnitsByTypeAndParent } from '../../../pages/userManagement/venuesView/venuesViewHelper';

export class VenueBranchPresentationStrategy
  implements OrgUnitPresentation<VenueBranch>
{
  public unitTranslationKey = 'onboarding.venueBranches';
  public orgUnitType = OrganizationUnitType.VENUE_BRANCH;

  getTableData(
    allOrgUnits: OrgUnit[],
    parentOrgUnitId: string | null,
  ): VenueBranch[] {
    if (parentOrgUnitId) {
      return getOrganizationUnitsByTypeAndParent(
        allOrgUnits,
        OrganizationUnitType.VENUE_BRANCH,
        parentOrgUnitId,
      ) as VenueBranch[];
    }

    const venueBranches: VenueBranch[] = allOrgUnits.filter(
      (orgUnit: OrgUnit) => orgUnit.type === OrganizationUnitType.VENUE_BRANCH,
    ) as VenueBranch[];

    return venueBranches;
  }

  getTableColumns(): VenuesViewTableColumns[] {
    return [
      {
        header: VenuesViewTableHeaderKey.VENUE_BRANCH_NAME,
        sortable: true,
        key: OrganizationUnitKey.NAME,
      },
      { header: VenuesViewTableHeaderKey.STATUS },
      { header: VenuesViewTableHeaderKey.ACTIVE_USERS },
      { header: VenuesViewTableHeaderKey.INACTIVE_USERS },
      { header: VenuesViewTableHeaderKey.ADDED_BY },
    ];
  }
  getKebabOptions(): OptionWithLoading<VenuesViewKebabOptions>[] {
    return [
      {
        loading: false,
        label: VenuesViewKebabOptions.EDIT_VENUE_BRANCH,
        value: VenuesViewKebabOptions.EDIT_VENUE_BRANCH,
      },
      {
        loading: false,
        label: VenuesViewKebabOptions.DELETE_VENUE_BRANCH,
        value: VenuesViewKebabOptions.DELETE_VENUE_BRANCH,
      },
    ];
  }
}
